<template>
  <div class="data modal-container">
    <div class="modal-header">
      <div class="corner-container left">
        <div>
          <div class="header-label"> <b> {{ headerText }} </b> </div>
        </div>
        <div>
          <div class="helper-text"> <b>Move-In Date</b> </div>
          <p class="helper-text-data"> {{ moveInDate }}</p>
        </div>
        <div>
          <div class="helper-text"> <b>Role</b> </div>
          <p class="helper-text-data"> {{ role }}</p>
        </div>
      </div>
      <div>
        <div class="circle">
          <button style="width: 100%; height: 100%;" @click="changeAssignee()">
            {{ userInitials }}
          </button>
        </div>
      </div>

      <div class="corner-container right">
        <button class="header-label" @click="$emit('close')">X</button>
        <div>
          <div class="helper-text"> <b>Status</b> </div>
          <p class="helper-text-data"> {{ status }}</p>
        </div>
        <div>
          <div class="helper-text"> <b>User ID</b> </div>
          <p class="helper-text-data"> {{ userId }}</p>
        </div>
      </div>

    </div>
    <div class="modal-fields">
      <div class="modal-field">
        <div class="helper-text">Name</div>
        <p class="center-text"> {{ name }}</p>
      </div>
      <div class="modal-field">
        <div class="helper-text">Phone Number</div>
        <p class="center-text"> {{ phone }}</p>
      </div>
      <div class="modal-field">
        <div class="helper-text">Email</div>
        <p class="center-text"> {{ email }}</p>
      </div>
      <div class="modal-field">
        <div class="helper-text">Address</div>
        <p class="center-text"> {{ address }}</p>
      </div>
      <!-- <div class="modal-field">
        <div class="helper-text"> Associated Users</div>
        <p v-for="associatedUser in associatedUsers" :key="associatedUser.toString()" class="center-text"> {{
          associatedUser.user_first_name }} {{ associatedUser.user_last_name }}: {{ associatedUser.unit_association }}
        </p>
      </div> -->
    </div>


    <div class="additional-data">
      <div class="additional-data-item">
        <b>
          <p>Household Count</p>
        </b>
        <br>
        <p>{{ householdCount }}</p>
      </div>
      <div style="display:block; width: 1px; height: 100%; background-color: white;"></div>
      <div class="additional-data-item">
        <b>
          <p>Number of Pets</p>
        </b>
        <br>
        <p>{{ numberOfPets }}</p>
      </div>
      <div style="display:block; width: 1px; height: 100%; background-color: white;"></div>
      <div class="additional-data-item">
        <b>
          <p>Number of Vehicles</p>
        </b>
        <br>
        <p>{{ numberOfVehicles }}</p>
      </div>
      <div style="display:block; width: 1px; height: 100%; background-color: white;"></div>
      <div class="additional-data-item">
        <b>
          <p>Guests Invited</p>
        </b>
        <br>
        <p>{{ guestsInvited }}</p>
      </div>
    </div>


    <div v-if="userData['custom:cts_role'] == 'admin' || userData['custom:cts_role'] == 'hoa_admin'">
      <div class="button-container">
        <button class="action-button" @click="addComment()">Update User Info</button>
        <button class="action-button suspended-button" @click="updateIncident()">Disable User</button>
      </div>
      <div class="button-container">
        <button class="validate button" @click="suspendUser()">Send Message</button>
      </div>
    </div>
    <div v-else>
      <div class="button-container">
        <button class="action-button" @click="editUser()">Edit User</button>
        <button class="action-button" @click="addSecondaryUser()">Add Secondary User</button>
      </div>
    </div>

  </div>
</template>

<script>
const NAME = 'users-modal'

export default {
  modalName: NAME,
  props: ["selectedUserData", "organizationData", "userData"],
  components: {
  },
  data() {
    return {
      modalName: NAME,
      suspended: false,
      inactive: true,
      showId: false,
      payload: { "uid": "38bf5676-eee0-4103-81a7-f812bb21d14e", "first_name": "Richard", "last_name": "Dale", "email": "rmd127@miami.edu", "phone": "9548052619", "address": "4143 43rd St, Sunnyside, NY 11104", "subdivision": "Fantasy Isle", "role": "resident", "notification_token": "ExponentPushToken[0k09k-Gs2cjrUr16ZjrZ02]", "unit_id": null, "carma": 1004499, "status": "active" }
    }
  },
  computed: {
    headerText: function () {
      return `${this.getMappedName(this.$props.organizationData.organization_id)}`
    },
    userInitials: function () {
      return `${this.$props.selectedUserData.first_name[0]}${this.$props.selectedUserData.last_name[0]}`
    },
    moveInDate: function () {
      return `${new Date(this.$props.selectedUserData.move_in_date).toLocaleDateString()}`
    },
    status: function () {
      return this.$props.selectedUserData.current_status
    },
    userId: function () {
      return this.$props.selectedUserData.uid
    },
    name: function () {
      return `${this.$props.selectedUserData.first_name} ${this.$props.selectedUserData.last_name}`
    },
    phone: function () {
      return this.$props.selectedUserData.primary_phone_number
    },
    email: function () {
      return this.$props.selectedUserData.primary_email_address
    },
    address: function () {
      return this.$props.selectedUserData.address
    },
    // unitAddressPreview: function () {
    //   let address = this.$props.unitData.unit_full_address
    //   return this.$props.unitData.unit_full_address.substring(0, address.indexOf(' '))
    // },
    householdCount: function () {
      return `0`

    },
    numberOfPets: function () {
      return `0`

    },
    numberOfVehicles: function () {
      return `0`

    },
    guestsInvited: function () {
      return `0`
    },
    role: function () {
      return this.$roleNameMap[this.$props.selectedUserData.role]
    },
    // associatedUsers: function () {
    //   if (this.$props.unitData.associated_users.length > 0 && this.$props.unitData.associated_users[0] != null) {
    //     return this.$props.unitData.associated_users
    //   }
    //   return null
    // }
  },
  methods: {
    show() {
      this.$modal.show();
    },
    close() {
      this.$modal.hide();
    },
    showKey() {
      console.log("show key...")
    },
    showIncidents() {
      console.log("show incidents...")
    },
    edit() {
      console.log("edit mode!")
    },
    editUser() {
      console.log("edit user...")
    },
    addSecondaryUser() {
      console.log("add user...")
    },
    suspendUser() {
      console.log("suspend user...")
    },
    showUserId() {
      this.showId = true
    },
    hideUserId() {
      this.showId = false
    },
    uploadAttachment() {
      alert("Upload Attachment")
    },
    changeAssignee() {
      alert("Change Assignee")
    },
    addComment() {
      alert("Add Comment")

    },
    updateIncident() {
      alert("Update Incident")

    },
    getMappedName(id) {
      return this.$organizationMap[id] ?? id
    }

  },
  created() {
    console.log("In modal")
    // make API request here to fill out payload fields
    // fetch or use axios?
  },
}
</script>

<style>
.modal-container {
  display: flex;
  flex-direction: column;
  background-color: #699991;
  color: white;
  border-radius: 4px;
}

.modal-header {
  padding: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.modal-field {
  padding: 1rem;
  font-size: 25px;
  border-bottom: 1px solid #87BAB7;
}

.modal-time-info {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.modal-time-inner {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  border-right: 1px solid #87BAB7;
  border-left: 1px solid #87BAB7;
}

.helper-text {
  text-align: left;
  font-size: 15px;
}

.circle {
  width: 160px;
  height: 160px;
  line-height: 160px;
  border-radius: 50%;
  font-size: 50px;
  color: #fff;
  text-align: center;
  background: #87BAB7;
}

.button-container {
  display: flex;
  flex-direction: row;
}

/* .action-button {
    margin: .5rem;
    color: white;
    background-color: #87BAB7;
    width: 45%;
    margin-left: auto;
    margin-right: auto;
    height: 3rem;
    border-radius: 5px;
  }
  .suspended-button {
    margin: .5rem;
    color: white;
    background-color: red;
    width: 45%;
    margin-left: auto;
    margin-right: auto;
    height: 3rem;
    border-radius: 5px;
  } */
.suspended-text {
  color: red;
}

.corner-container {
  display: flex;
  flex-direction: column;
}

.mini-text {
  padding-top: 5px;
  font-size: 12px;
}
</style>
